export default __webpack_public_path__ + "static/media/2008outback_2.9972dbc7.jpg";